export const images = {
  logos: {
    sologenicWhiteLogo: require("../images/logos/sologenic_white_logo.png"),
    sologenicBlackLogo: require("../images/logos/sologenic_black_logo.png"),
    coinfieldWhiteLogo: require("../images/logos/coinfield_white_logo.png"),
    coinfieldBlackLogo: require("../images/logos/coinfield_black_logo.png"),
    appleStore: require("../images/logos/app_store.png"),
    googlePlay: require("../images/logos/google_play.png"),
    coinfieldSmall: require("../images/logos/coinfield_coins.png"),
    // methodLogo: require("""../images/logos/"),
  },
  icons: {
    withAccountSolo: require("../images/icons/haveacc_icon.png"),
    withAccount: require("../images/icons/haveacc_icon_cf.png"),
    withoutAccountSolo: require("../images/icons/nothaveacc_icon.png"),
    withoutAccount: require("../images/icons/nothaveacc_icon_cf.png"),
    error: require("../images/icons/error_icon.png"),
    lock: require("../images/icons/lock_icon.png"),
    camera: require("../images/icons/camera-icon.png"),
    upload: require("../images/icons/upload-icon.png"),
    cameraWhite: require("../images/icons/camera-icon-white.png"),
    uploadWhite: require("../images/icons/upload-icon-white.png"),
    driving_license: require("../images/icons/drivers-icon.png"),
    passport: require("../images/icons/passport-icon.png"),
    id_card: require("../images/icons/id-icon.png"),
    driving_license_white: require("../images/icons/drivers-icon-white.png"),
    passport_white: require("../images/icons/passport-icon-white.png"),
    id_card_white: require("../images/icons/id-icon-white.png"),
    selfie: require("../images/icons/selfie-icon.png"),
    poa: require("../images/icons/poa-icon.png"),
    selfie_white: require("../images/icons/selfie-icon-white.png"),
    poa_white: require("../images/icons/poa-icon-white.png"),
  },
  illustrations: {
    bitcoinIllustration: require("../images/illustrations/bitcoin_illustration.png"),
    loginIllustration: require("../images/illustrations/login_illustration.png"),
    worldIllustration: require("../images/illustrations/world_illustration.png"),
    signupIllustration: require("../images/illustrations/signup_illustration.png"),
    envelopeSolo: require("../images/illustrations/envelope_solo.png"),
    rejectedSolo: require("../images/illustrations/rejected_solo.png"),
    reviewSolo: require("../images/illustrations/review_solo.png"),
    envelopeCF: require("../images/illustrations/envelope_cf.png"),
    rejectedCF: require("../images/illustrations/rejected_cf.png"),
    reviewCF: require("../images/illustrations/review_cf.png"),
    idFront: require("../images/illustrations/id_front.png"),
    idBack: require("../images/illustrations/id_back.png"),
    passport: require("../images/illustrations/passport.png"),
    selfieSample: require("../images/illustrations/selfie_sample.png"),
    poaSample: require("../images/illustrations/poa_sample.png"),
    phoneIllustrationSolo: require("../images/illustrations/phone_illustration_solo.png"),
    idIllustrationSolo: require("../images/illustrations/id_illustration_solo.png"),
    profileIllustrationSolo: require("../images/illustrations/profile_illustration_solo.png"),
    documentIllustrationSolo: require("../images/illustrations/document_illustration_solo.png"),
    experienceIllustrationSolo: require("../images/illustrations/experience_illustration_solo.png"),
    phoneIllustration: require("../images/illustrations/phone_illustration.png"),
    idIllustration: require("../images/illustrations/id_illustration.png"),
    profileIllustration: require("../images/illustrations/profile_illustration.png"),
    documentIllustration: require("../images/illustrations/document_illustration.png"),
    experienceIllustration: require("../images/illustrations/experience_illustration.png"),
    notFound: require("../images/illustrations/notfound_illustration.png"),
    corpCF1: require("../images/illustrations/corp_cf_1.png"),
    corpCF2: require("../images/illustrations/corp_cf_2.png"),
    corpCF3: require("../images/illustrations/corp_cf_3.png"),
    corpCF4: require("../images/illustrations/corp_cf_4.png"),
    corpCF5: require("../images/illustrations/corp_cf_5.png"),
    corpCF6: require("../images/illustrations/corp_cf_6.png"),
    corpCF7: require("../images/illustrations/corp_cf_7.png"),
    corpSolo1: require("../images/illustrations/corp_solo_1.png"),
    corpSolo2: require("../images/illustrations/corp_solo_2.png"),
    corpSolo3: require("../images/illustrations/corp_solo_3.png"),
    corpSolo4: require("../images/illustrations/corp_solo_4.png"),
    corpSolo5: require("../images/illustrations/corp_solo_5.png"),
    corpSolo6: require("../images/illustrations/corp_solo_6.png"),
    corpSolo7: require("../images/illustrations/corp_solo_7.png"),
  },
};
